import React, {useEffect,useRef,useState} from "react";
import ImageWithBasePath from "../../../core/img";
import FeatherIcon from "feather-icons-react";
import Slider from "react-slick";
import {Link,useNavigate} from "react-router-dom";
import {all_routes} from "../../router/all_routes";
import {Rating} from 'react-simple-star-rating';
import {Toaster} from 'react-hot-toast';
import Modal_Image_Slide_Show from "./modalImageSlideShow";
import Modal_Image_More_Slide_Show from "./modalImageMoreSlideShow";
import series from 'async/series';
// -- biz9 --
import {UrlParam} from "biz9-react-utility";
import {Remote} from "biz9-remote";
import {Favorite_Service,Favorite_Url,Favorite_Logic} from "biz9-favorite";
import {UrlQuery} from "biz9-react-utility";
import {Log,Num,Str,DateTime,Status_Type,Obj,Response_Field} from "biz9-utility";
import {Config,Field,Message,Title,Type} from "../../../constant";
import {App,Image,Style,User,Toast_Message,Storage,Field_Logic} from "../../../project";
import {Store_Service,Store_Type,Store_Stat,Store_Logic,Cart_Logic,Order_Logic,Basket_Logic,Basket_Data} from "biz9-store";
import {Image_Format} from "biz9-image";
import {User_Logic} from "biz9-user";
import {Stat_Logic} from "biz9-stat";
import {Data_Logic} from "biz9-data-app";
import {Review_Service,Review_Url,Review_Logic,Review_Table,Review_Stat,Review_Field} from "biz9-review";
import './app_detail.css';
import SubValue from "../../subValue";
import {Portal_Type,Portal_Field,Portal_Remote_Stat,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type,Portal_Remote_Favorite,Portal_Remote_Review,Portal_Remote_Store_Cart} from "biz9-portal-app";

const Product_App_Detail = () => {
    /* -- DEFINE -- *
     * 9_define
     * --- DATA-RESPONSE ---
     * data - data-obj
     * - product_app -- obj -- data[Type.PRODUCT_APP]
     * - is_favorite -- obj -- data[Portal_Type.IS_FAVORITE]
     * - detail_images -- array -- data[Portal_Type.IMAGE_GALLERY_DETAIL]
     * - info_images -- array -- data[Portal_Type.IMAGE_GALLERY_INFO]
     * - main_images -- array -- data[Portal_Type.IMAGE_GALLERY_MAIN]
     * - reviews - array - data[Portal_Type.REVIEWS]
     * - product_sub_type_content_management_systems -- array -- data[Type.PRODUCT_SUB_TYPE_CONTENT_MANAGEMENT_SYSTEMS]
     * - product_sub_type_hosting_types -- array -- data[Type.PRODUCT_SUB_TYPE_HOSTING_TYPES]
     * - product_sub_type_hosting_durations -- array -- data[Type.PRODUCT_SUB_TYPE_HOSTING_DURATIONS]
     * - product_sub_type_spec_weekly_hours -- array -- data[Type.PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOURS]
     *  ---- BUTTONZ ----
     * btn_post_preview_pay -- open pay modal.
     * btn_post_favorite -- add to favorites.
     * btn_post_pay -- pay, redirect to checkout page.
     * btn_post_review -- post review.
     * btn_delete_review -- delete review.

     *  ---- FIELDZ ----
     *  demo - string
     *  video - string
     *  android - string
     *  ios - string
     *  source - string
     */
    const query = UrlQuery();
    const param = UrlParam();
    const alert_prop = useRef(null);
    const navigate = useNavigate();
    //
    const [user,setUser] = useState(User.get());
    const [val_title_url,setValTitleUrl] = useState(null);
    //
    const [val_review_rating,setValReviewRating] = useState(5)
        const [val_review_title,setValReviewTitle] = useState(!user.is_guest ? "Title " + Num.get_id() : "Please Login In");
    const [val_review_name,setValReviewName] = useState(user ? user.username : "Please Login In");
    const [val_review_location,setValLocation] = useState(user ? User_Logic.get_country_state_city(user) :"" );
    const [val_review_comment,setValReviewComment] = useState("");
    const [val_app_cost,setValAppCost] = useState("");
    const [val_app_pay_now_cost,setValAppPayNowCost] = useState("");
    const [val_favorite_title,setValFavoriteTitle] = useState("Add to Favorites")
        // -- image_gallery --
        const [show_image_primary,setShowImagePrimary] = useState(false);
    const [show_image_thumb,setShowImageThumb] = useState(false);
    const [main_images,setMainImages] = useState<any[]>([]);
    const [info_images,setInfoImages] = useState<any[]>([]);
    const [detail_images,setDetailImages] = useState<any[]>([]);
    // -- product --
    const [product,setProduct] = useState(Data_Logic.get(0,Portal_Table.PRODUCT));
    const [products,setProducts] = useState([]);
    const [cart,setCart] = useState(Data_Logic.get(Portal_Table.CART,0,{data:{grand_total:0,cart_items:[]}}));
    // -- cms --
    const [product_sub_cms_select,setProductSubCmsSelect] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{value:'0',title:'',cost:'0'}}));
    const [product_sub_cms_items,setProductSubCmsItems] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:3,data:{value:'',title:'',cost:'0'}}));
    const [val_product_sub_cms_selected_title,setValProductSubCmsSelectTitle] = useState("");
    //-- hosting-type --
    const [product_sub_hosting_type_select,setProductSubHostingTypeSelect] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{value:'0',title:'',cost:'0'}}));
    const [product_sub_hosting_type_items,setProductSubHostingTypeItems] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:3,data:{value:'0',title:'',cost:'0'}}));
    const [val_product_sub_hosting_type_selected_title,setValProductSubHostingTypeSelectTitle] = useState("");
    //-- hosting-duration --
    const [product_sub_hosting_duration_select,setProductSubHostingDurationSelect] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{value:'0',title:'',cost:'0'}}));
    const [product_sub_hosting_duration_items,setProductSubHostingDurationItems] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:3,data:{value:'0',title:'',cost:'0'}}));
    const [val_product_sub_hosting_duration_selected_title,setValProductSubHostingDurationSelectTitle] = useState("");
    //-- spec-weekly-hour --
    const [product_sub_spec_weekly_hour_select,setProductSubSpecWeeklyHourSelect] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{value:'0',title:'',cost:'0'}}));
    const [product_sub_spec_weekly_hour_items,setProductSubSpecWeeklyHourItems] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{test:true,count:3,data:{value:'0',title:'',cost:'0'}}));
    const [val_product_sub_spec_weekly_hour_selected_title,setValProductSubSpecWeeklyHourSelectedTitle] = useState("");
    // -- payment-plan-types --
    const [payment_plan_type_select,setPaymentPlanTypeSelect] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{title:'1 Payment',cost:'0',value:'0'}}));
    const [payment_plan_types,setPaymentPlanTypes] = useState([]);
    const [val_payment_plan_type_selected_title,setValPaymentPlanTypeSelectTitle] = useState("");

    // -- reviews --
    const [reviews,setReviews] = useState([]);
    //const [tag_list, setTagList] = useState([]);
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
    const [basket,setBasket] = useState(Basket_Data.get(user.id,{has_window:false}));

    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            setNav1(sliderRef1.current);
            setNav2(sliderRef2.current);
            get_page_data();
            }, [param.title_url]);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(param.title_url){
            get_data(param.title_url);
            }
            },[param.title_url]);
    async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.PRODUCT.title_url,option);
        bind_page(data);
    };
    async function get_data(title_url) {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10,user_id:User.get().id};
        const [response,data] = await Portal_Remote_Page.get_product_items(App.get_url(Portal_Page.PRODUCT[Portal_Type.ITEMS_URL]),title_url,option);
        bind_items(title_url,data);
        post_stat(data[Type.PRODUCT_APP],user.id);
        Toast_Message.dismiss();
    };
    async function post_stat(product,user_id) {
        // -- post-stat --
        let stat_option = {is_unique:true,update_parent_count:true};
        let parent = Data_Logic.get(Portal_Table.PRODCUT,product.id,
                {data:{
                    title:product.title,
                    title_url:product.title_url,
                    cost:product.cost,
                    category:product.category,
                    type:product.type
                }});
        let stat = Stat_Logic.get({table:Portal_Table.PRODUCT,id:product.id},Portal_Stat.POST_VIEW,user_id,parent);
        const [biz_response,biz_data] = await Portal_Remote_Stat.post(App.get_url(Portal_Url.STAT_POST),stat,stat_option);
    };
    async function bind_page(data) {
        // -- page --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
    async function bind_sub_values(data_sub_group) {
        // -- bind-sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
async function update_sub_value(sub_value) {
    // -- page-edit-sub-values --
    if(sub_value.type != Sub_Value_Type.ITEMS){
        setSubValueGroup(sub_value_group => ({
                    ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                    }
                    }));
    }else{
        setSubValueGroup(sub_value_group => ({
                    ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                    }
                    }));
    }
}
async function bind_items(title_url,data){
    // -- title_url --
    setValTitleUrl(title_url);
    // -- product --
    setProduct(data[Type.PRODUCT_APP]);
    // -- app_cost --
    setValAppCost(data[Type.PRODUCT_APP].cost);
    // -- images --
    if(data[Portal_Type.IMAGE_GALLERY_MAIN].length>0){
        setMainImages(data[Portal_Type.IMAGE_GALLERY_MAIN]);
    }
    if(data[Portal_Type.IMAGE_GALLERY_INFO].length>0){
        setInfoImages(data[Portal_Type.IMAGE_GALLERY_INFO]);
    }
    if(data[Portal_Type.IMAGE_GALLERY_DETAIL].length>0){
        setDetailImages(data[Portal_Type.IMAGE_GALLERY_DETAIL]);
    }
    // -- reviews --
    setReviews(data[Portal_Type.REVIEWS]);
    // -- products --
    bind_products(data);
    // -- favorite --
    if(data[Portal_Type.IS_FAVORITE]){
        setValFavoriteTitle("Added to Favorites.");
    }
}
const bind_products = (data) => {
    // -- product-sub-cms --
    let product_sub_cms_select = !Obj.check_is_empty(data[Type.PRODUCT_SUB_TYPE_CONTENT_MANAGEMENT_SYSTEMS][0]) ? data[Type.PRODUCT_SUB_TYPE_CONTENT_MANAGEMENT_SYSTEMS][0]:{};
    setProductSubCmsItems(!Obj.check_is_empty(data[Type.PRODUCT_SUB_TYPE_CONTENT_MANAGEMENT_SYSTEMS]) ? data[Type.PRODUCT_SUB_TYPE_CONTENT_MANAGEMENT_SYSTEMS]:[]);
    setProductSubCmsSelect(product_sub_cms_select);
    setValProductSubCmsSelectTitle(product_sub_cms_select.title);
    // -- product-sub-hosting-type --
    let product_sub_hosting_type_select = !Obj.check_is_empty(data[Type.PRODUCT_SUB_TYPE_HOSTING_TYPES][0]) ? data[Type.PRODUCT_SUB_TYPE_HOSTING_TYPES][0]:{};
    setProductSubHostingTypeItems(!Obj.check_is_empty(data[Type.PRODUCT_SUB_TYPE_HOSTING_TYPES]) ? data[Type.PRODUCT_SUB_TYPE_HOSTING_TYPES]:[]);
    setProductSubHostingTypeSelect(product_sub_hosting_type_select);
    setValProductSubHostingTypeSelectTitle(product_sub_hosting_type_select.title);
    // -- product-sub-spec-weekly-hour --
    let product_sub_spec_weekly_hour_select = data[Type.PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOURS][0];
    setProductSubSpecWeeklyHourItems(!Obj.check_is_empty(data[Type.PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOURS]) ? data[Type.PRODUCT_SUB_TYPE_SPEC_WEEKLY_HOURS] : []);
    setProductSubSpecWeeklyHourSelect(product_sub_spec_weekly_hour_select);
    setValProductSubSpecWeeklyHourSelectedTitle(product_sub_spec_weekly_hour_select.title);
    // -- product-sub-hosting-duration --
    // -- update-hosting-duration-cost --
    let update_product_sub_hosting_duration_items = update_hosting_duration_cost(product_sub_hosting_type_select.cost,data[Type.PRODUCT_SUB_TYPE_HOSTING_DURATIONS]);
    setProductSubHostingDurationSelect(update_product_sub_hosting_duration_items[0]);
    setValProductSubHostingDurationSelectTitle(update_product_sub_hosting_duration_items[0].title);
    // -- update-basket --
    let update_basket = Basket_Data.update(user.id,data[Type.PRODUCT_APP],[
            product_sub_hosting_type_select,
            update_product_sub_hosting_duration_items[0],
            product_sub_cms_select,
            product_sub_spec_weekly_hour_select
    ])
        setBasket(update_basket);
    // -- totals --
    update_totals(update_basket);
}
const update_hosting_duration_cost = (hosting_type_cost,product_sub_hosting_duration_items) => {
    for(const hosting_duration of product_sub_hosting_duration_items){
        hosting_duration.cost = hosting_duration.month_count * hosting_type_cost;
    }
    setProductSubHostingDurationItems(product_sub_hosting_duration_items);
    return product_sub_hosting_duration_items;
}
const update_totals = (basket) => {
    let grand_total = Basket_Logic.get_total(basket).grand_total;
    setValAppCost(grand_total);
    post_payment_plan_types(grand_total,true)
}
const post_payment_plan_types = (cost,update_types) => {
    let payment_plan_types = App.get_app_payment_plan_types(cost);
    if(update_types){
        setPaymentPlanTypes(payment_plan_types);;
        setPaymentPlanTypeSelect(payment_plan_types.find(item => item.title === payment_plan_types[0].title));
        setValPaymentPlanTypeSelectTitle(payment_plan_types.find(item => item.title === payment_plan_types[0].title).title);
        setValAppPayNowCost(payment_plan_types[0].value);
    }
    return payment_plan_types;
}
const update_payment_plan_type = (event) => {
    // -- update-payment-plan-type
    let payment_plan_select = payment_plan_types.find(item => item.title === event.target.value)
        setPaymentPlanTypeSelect(payment_plan_select);
    setValPaymentPlanTypeSelectTitle(event.target.value);
    setValAppPayNowCost(payment_plan_select.value);
};
const update_product_sub_spec_weekly_hour = (event) => {
    // -- update-product-sub-spec-weekly-hour
    let product_sub_select = product_sub_spec_weekly_hour_items.find(item => item.title === event.target.value)
        setProductSubSpecWeeklyHourSelect(product_sub_select);
    setValProductSubSpecWeeklyHourSelectedTitle(event.target.value);
    // -- update-basket --
    let update_basket = Basket_Data.update(user.id,product,[product_sub_hosting_type_select,product_sub_hosting_duration_select,product_sub_spec_weekly_hour_select,product_sub_select]);
    setBasket(update_basket);
    update_totals(update_basket);
};
const update_product_sub_cms = (event) => {
    // update-product-sub-cms
    let product_sub_select = product_sub_cms_items.find(item => item.title === event.target.value)
        setProductSubCmsSelect(product_sub_select);
    setValProductSubCmsSelectTitle(event.target.value);
    // -- update-basket --
    let update_basket = Basket_Data.update(user.id,product,[product_sub_hosting_type_select,product_sub_hosting_duration_select,product_sub_spec_weekly_hour_select,product_sub_select]);
    setBasket(update_basket);
    update_totals(update_basket);
};
const update_product_sub_hosting_type = (event) => {
    // update-product-sub-hosting-type
    let product_sub_select = product_sub_hosting_type_items.find(item => item.title === event.target.value)
        setProductSubHostingTypeSelect(product_sub_select);
    setValProductSubHostingTypeSelectTitle(event.target.value);
    // -- update-hosting-duration-cost --
    update_hosting_duration_cost(product_sub_select.cost,product_sub_hosting_duration_items);
    // -- update-basket --
    let update_basket = Basket_Data.update(user.id,product,[product_sub_hosting_type_select,product_sub_hosting_duration_select,product_sub_spec_weekly_hour_select,product_sub_select]);
    setBasket(update_basket);
    update_totals(update_basket);
};
const update_product_sub_hosting_duration = (event) => {
    // update-product-sub-hosting-duration
    let product_sub_select = product_sub_hosting_duration_items.find(item => item.title === event.target.value)
        setProductSubHostingDurationSelect(product_sub_select);
    setValProductSubHostingDurationSelectTitle(event.target.value);
    // -- update-basket --
    let update_basket = Basket_Data.update(user.id,product,[product_sub_hosting_type_select,product_sub_hosting_duration_select,product_sub_spec_weekly_hour_select,product_sub_select]);
    setBasket(update_basket);
    update_totals(update_basket);
};


const updateValReviewTitle = (event) => {
    setValReviewTitle(event.target.value);
};
const updateValReviewComment = (event) => {
    setValReviewComment(event.target.value);
};
const updateValReviewRating = (val: number) => {
    setValReviewRating(val)
}
function btn_post_pay() {
    window.location.href = all_routes.product_app_checkout;
};
function btn_post_preview_pay(){
    let basket = {};
    let cart = {};
    series([
            async function(call) {
            // -- get-basket -- storage-data-window --
            basket = Basket_Data.get(user.id);
            basket[Type.PAYMENT_PLAN_TYPE] = payment_plan_type_select.title + " - " +Str.get_money(payment_plan_type_select.value);
            basket[Portal_Type.PAY_NOW_COST] = payment_plan_type_select.value;
            basket[Type.APP_TYPE] =  product.type;
            basket[Type.APP_CATEGORY] =  product.category;
            },
            async function(call) {
            // --  post-cart -- remote-data-response --
            const [response,data] = await Portal_Remote_Store_Cart.post(App.get_url(Portal_Url.STORE_CART_POST),basket);
            cart = data;
            Log.w('11_cart',cart);
            setCart(Cart_Logic.get_total(cart));
            Storage.post_cart(data);
            },
    ],
    function(err, results) {
    console.log('done');
    });

};

async function btn_delete_review(id: any){
    /*
       const review = Review_Logic.get(Review_Table.REVIEW,product.id,user.table,user.id,val_review_title,val_review_comment,val_review_rating);
       const [response,data] = await Review_Service.delete(App.get_url(Review_Url.REVIEW_DELETE),product,id);
       setReviews(Obj.filter(Portal_Field.ID,id,reviews));
       Toast_Message.success(response.message);
       */
};
async function btn_post_review(){
    if(user.is_guest){
       alert(Title.LABEL_LOGIN_TO_ADD_REVIEW);
    }else{
        let review = Review_Logic.get(product,user,val_review_title,val_review_comment,val_review_rating);
        const [response,data] = await Portal_Remote_Review.post(App.get_url(Portal_Url.REVIEW_POST),review);
        if(response[Response_Field.STATUS] == Status_Type.SUCCESS && !Str.check_is_null(data.parent.id)){
            product[Review_Field.REVIEW_RATING_COUNT] = data[Portal_Type.PARENT][Review_Field.REVIEW_RATING_COUNT];
            product[Review_Field.REVIEW_COUNT] = data[Portal_Type.PARENT][Review_Field.REVIEW_COUNT];
            product[Review_Field.REVIEW_RATING_AVG] = data[Portal_Type.PARENT][Review_Field.REVIEW_RATING_AVG];
            setProduct(product);
            setReviews([...reviews,data[Portal_Type.REVIEW]]);
            setValReviewComment("");
            Toast_Message.success(response.message);
        }
    }
};
async function btn_post_favorite() {
    if(!user.is_guest){
        let favorite = Favorite_Logic.get(product,User.get());
        const [response,data] = await Portal_Remote_Favorite.post(App.get_url(Portal_Url.FAVORITE_POST),favorite);
        setValFavoriteTitle("Added to Favorites");
        Toast_Message.success(response.message);
    }else{
        alert("Please login to add favorites.");
    }
}
const routes = all_routes;
const sliderRef1 = useRef(null);
const sliderRef2 = useRef(null);
const [nav1, setNav1] = useState(null);
const [nav2, setNav2] = useState(null);
const [selectedItems, setSelectedItems] = useState(Array(10).fill(false));
const handleItemClick = (index: number) => {
    setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = [...prevSelectedItems];
            updatedSelectedItems[index] = !updatedSelectedItems[index];
            return updatedSelectedItems;
            });
};
useEffect(() => {
        setNav1(sliderRef1.current);
        setNav2(sliderRef2.current);
        }, []);
const imgslideroption = {
dots: false,
      nav: false,
      infinite: true,
      speed: 500,
      swipe:true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1200,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 600,
            settings: {
slidesToShow: 1,
            },
      },

      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const slideslideroption = {
dots: true,
      nav: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      draggable:true,
      tochMove:true,
      swipe:true,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 1,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const recentimgslideroption  = {
dots: false,
      loop:true,
      arrows: true,
      nav: true,
      infinite: true,
      smartSpeed: 500,
      slidesToShow: 3,
      slidesToScroll: 6,
      responsive: [
      {
breakpoint: 1200,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 600,
            settings: {
slidesToShow: 1,
            },
      },

      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const settings1 = {
dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: nav2 || undefined, // Link to the second slider
      ref: (slider: any) => (sliderRef1.current = slider), // Assign the slider ref

};

const settings2 = {
dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: nav1 || undefined, // Link to the first slider
      ref: (slider: any) => (sliderRef2.current = slider), // Assign the slider ref

};

type SectionState = {
mostRecent: boolean;
};

const [activeSections, setActiveSections] = useState<SectionState>({
mostRecent: false,
});

const toggleSection = (section: keyof SectionState) => {
    setActiveSections((prevState) => {
            const newState: SectionState = {
mostRecent: false,
};
return {
...newState,
[section]: !prevState[section],
};
});
};


const containerCenter = {
display: 'flex',
         justifyContent: 'center', // Note the camelCase for CSS properties
         alignItems: 'center',
         height: '100px',
};

return (
        <>
        <Toaster />
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info breadcrumb-info">
        <div className="breadcrumb-img">
        <div className="breadcrumb-left">
        <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="" />
        </div>
        </div>
        <div className="container">
        <div className="row align-items-center">
        <div className="col-lg-8 col-12 text-start">
        <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol className="breadcrumb">
        <li className="breadcrumb-item">
        <Link to={routes.home}>Home</Link>
        </li>
        <li className="breadcrumb-item">
        <Link to={all_routes.product_app}>Search</Link>
        </li>
<li className="breadcrumb-item active" aria-current="page">
App Details
</li>
</ol>
</nav>
<h2 className="breadcrumb-title">
{product.title}
</h2>
<ul className="info-links">
<li>
{Array.from({ length: parseInt(product[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
            <i key={index} className="ti ti-star-filled text-warning" />
            ))}
({product[Review_Field.REVIEW_COUNT]}) {Title.LABEL_REVIEWS}
</li>
<li>
<i className="ti ti-calendar-clock text-warning" />
{Title.LABEL_ADDED_ON} : {DateTime.get_date_short(product.date_create)}
</li>

</ul>
</div>
<div className="col-lg-4 col-12">
<ul className="breadcrumb-links service-details">
<li className="mb-3 me-0">
<Link onClick={() => btn_post_favorite()} to="#">
<span>
<i className="ti ti-heart text-warning" />
</span>
{val_favorite_title}
</Link>
</li>
<li className="me-0">
<div className="social-links d-flex align-items-center breadcrumb-social justify-content-lg-end">
{" "}
Share
<ul className="ms-3">
<li>
<Link to="#">
<i className="fa-brands fa-facebook" />
</Link>
</li>

<li>
<Link to="#">
<i className="fa-brands fa-x-twitter" />
</Link>
</li>

</ul>
</div>
</li>
</ul>
</div>
</div>
</div>
</div>
{/* /Breadcrumb */}
{/* Content */}
<div className="page-content content">
<div className="container">
<div className="row">
{/* Service Details */}
<div className="col-lg-8"  >

{/* INFO-START */}
<div className="service-wrap" style={{display: product.image_filename ? 'none' : 'block'}} >
<ImageWithBasePath src={Image.get_url(product.image_filename,Image_Format.SQUARE_LARGE)} className="img-fluid" alt="" />
</div>
{/* INFO-END */}



{/* Slider */}
<div className="slider-card common-slider-nav" hidden={main_images.length<=0}>

<div className="slider service-slider">

<Slider  {...settings1}>
{main_images.map((item) => (
            <div key={item.id} className="service-img-wrap">
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt='' />
            </div>
            ))}
</Slider>
</div>
<div className="slider slider-nav-thumbnails" >
<Slider {...settings2}>
{main_images.map((item) => (
            <div key={item.id}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} className="img-fluid" alt="" />
            </div>
            ))}
</Slider>




</div>
</div>
{/* /Slider */}

{/* BUTTON-START */}
<div className="service-wrap" >

<div style={containerCenter} className="d-flex align-items-center" >

<Link to="#" data-bs-toggle="modal" data-bs-target="#modal_more_slide_show" className="btn btn-primary" style={{  borderColor:"#DC143C", backgroundColor:"#DC143C",  marginRight:"10px" }} hidden={detail_images.length <= 0}>
{Title.LABEL_IMAGES}
</Link>


<Link to="#" data-bs-toggle="modal" data-bs-target="#modal_slide_show" className="btn btn-primary" style={{  borderColor:"#FF00FF", backgroundColor:"#FF00FF",  marginRight:"10px" }} hidden={detail_images.length <= 0}>
{Title.LABEL_SCREENSHOTS}
</Link>

<Link to={product.demo} target='_blank'  className="btn btn-primary" style={{ backgroundColor:"#32CD32",marginRight:"10px" }} hidden={Str.check_is_null(product.demo)}>
{Title.LABEL_DEMO}
</Link>
<Link to={product.video} target='_blank'  className="btn btn-primary" style={{ backgroundColor:"#FFA500",  borderColor:"#FFA500", marginRight:"10px" }} hidden={Str.check_is_null(product.video)}>
{Title.LABEL_VIDEO}
</Link>
<Link to={product.android} target='_blank'  className="btn btn-primary" style={{ borderColor:"#8B8000",  backgroundColor:"#8B8000" ,marginRight:"10px" }} hidden={Str.check_is_null(product.android)}>
{Title.LABEL_ANDROID}
</Link>

<Link to={product.ios} target='_blank'  className="btn btn-primary" style={{  borderColor:"#888888",backgroundColor:"#888888",marginRight:"10px" }} hidden={Str.check_is_null(product.ios)}>
{Title.LABEL_IOS}
</Link>
<Link to={product.reference} target='_blank'  className="btn btn-primary" style={{   borderColor:"#0000FF",backgroundColor:"#0000FF"}} hidden={Str.check_is_null(product.reference)}>
{Title.LABEL_REFERENCE}
</Link>

</div>


</div>
{/* BUTTON-END */}



{/* INFO-START */}
<div className="service-wrap" hidden={info_images.length<=0}>
{info_images.map((item) => (
            <div  key={item.id}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.ORIGINAL)} className="img-fluid" alt="" />
            </div>
            ))}
</div>
{/* INFO-END */}


{/* ABOUT-START */}
<div className="service-wrap" hidden={Str.check_is_null(product.note)}>
<h3>About This App</h3>
<div className="containerStyle"   dangerouslySetInnerHTML={{__html: Str.get_quill_html(product.note)}}></div>
</div>
{/* ABOUT-END */}


{/* Review Lists */}
<div className="review-widget">
<div className="review-title sort-search-gigs">
<div className="row align-items-center">
<div className="col-sm-6">
<h3>{Title.LABEL_REVIEWS} ({product[Review_Field.REVIEW_RATING_AVG]})</h3>
</div>
<div className="col-sm-6">
<div className="filters-wrap sort-categories justify-content-end">
<div className={`collapse-card float-lg-end ${
    activeSections.mostRecent ? "active" : ""
}`}>
<div
id="categories"
className={`collapse-body ${
    activeSections.mostRecent ? "active" : "enable"
}`}
style={{
display: activeSections.mostRecent
             ? "block"
             : "none",
}}
>
<div className="form-group search-group">
<span className="search-icon">
<i className="feather icon-search" />
</span>
<input
type="text"
className="form-control"
placeholder="Search Category"
/>
</div>
<ul className="checkbox-list categories-lists">
<li className="active">
<label className="custom_check">
<span className="checked-title"> Recent</span>
</label>
</li>
<li>
<label className="custom_check">
<span className="checked-title">Oldest </span>
</label>
</li>
</ul>
</div>
</div>
</div>
</div>
</div>
</div>
{/* Total Ratings */}
<div className="total-rating align-items-center">
<div className="total-reviews text-center bg-white">
<h6> {Title.LABEL_REVIEWS_AND_RATINGS} </h6>
<h2> {!Str.check_is_null(product[Review_Field.REVIEW_RATING_AVG]) ? parseInt(product[Review_Field.REVIEW_RATING_AVG]): "0" } / 5 </h2>
<div className="icons d-flex align-items-center justify-content-center gap-1 mb-2">
{Array.from({ length: parseInt(product[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
            <i key={index} className="ti ti-star-filled text-warning" />
            ))}
</div>
<p className="text-center">Based On {product[Review_Field.REVIEW_COUNT]} {Title.LABEL_REVIEWS} </p>
</div>
</div>
{/* Total Ratings */}
<ul className="review-lists home-reviews">

{reviews.map((review) => (
            <li key={review.id}>
            <div className="review-wrap">
            <div className="review-user-info">
            {
            <div className="review-img">
            <ImageWithBasePath src={Image.get_url(review.user.image_filename,Image_Format.SQUARE_THUMB,{table:Portal_Table.USER})} alt="" />
            </div>
            }
            <div className="reviewer-info">
            <div className="reviewer-loc">
            <h6>
            <Link to="#">{review.title + " " + review[Review_Field.RATING] }</Link>
            </h6>
            </div>
            <div className="reviewer-rating">
            <div className="star-rate">
            <span className="ratings">
            {Array.from({ length: parseInt(review[Review_Field.RATING]) }).map((_, index) => (
                        <i key={index} className="fa-solid fa-star filled" />
                        ))}
</span>
    </div>
    </div>
    <div className="reviewer-time">
    <p>{DateTime.get_pretty(review.date_create)}</p> <p> <i>{review.user.username}{" - "} {User_Logic.get_country_state_city(review.user)}</i> </p>
    </div>
    </div>
    </div>
    <div className="review-content">
    <p>
    {review.comment}
</p>
{/*
    <Link to="#" className="reply-btn bg-light">
    <i className="feather icon-corner-up-left" />
    Reply
    </Link>
    */}
</div>
</div>
</li>
))}

</ul>
{/*
    <div className="text-center dark-btn">
    <Link to={routes.faq} className="btn btn-dark text-center fs-13">
    {" "}
    Load More
    </Link>
    </div>
    */}
</div>
{/* /Review Lists */}
{/* Review Tags */}
<div className="login-card">
<div className="login-heading text-start mb-4">
<h5>{Title.LABEL_LEAVE_A_REVIEW}</h5>
</div>
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark mb-1">
Your Rating <span className="text-primary">*</span>
</label>
<Rating className="mb-1 fw-medium text-dark mb-1" onClick={updateValReviewRating} initialValue={val_review_rating} />
</div>
<div className="row">
<div className="col-lg-12">
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">Title <span className="text-primary">*</span>  </label>
<input value={val_review_title}  disabled={user.is_guest? true: false} onChange={updateValReviewTitle} type="text" className="form-control"/>
</div>
</div>
<div style={{ display: user.is_guest ? 'none' : 'block' }} className="col-lg-6">
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">
UserName <span className="text-primary">*</span>
</label>
<input value={val_review_name} disabled={true} type="text" className="form-control" />
</div>
</div>
<div  style={{ display: user.is_guest ? 'none' : 'inline' }} className="col-lg-6">
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">
{" "}
Location <span className="text-primary">*</span>
</label>
<input value={val_review_location} disabled={true} type="text" className="form-control" />
</div>
</div>

<div   style={{ display: user.is_guest ? 'none' : 'inline' }} className="col-lg-12">
<div className="form-wrap form-focus">
<label className="mb-1 fw-medium text-dark">
{" "}
Review<span className="text-primary">*</span>
</label>
<textarea  value={val_review_comment} className="form-control text-area" defaultValue={""} onChange={updateValReviewComment} />
</div>
</div>
</div>
<Link  onClick={() => btn_post_review()} to="#" className="btn btn-primary member-btn">
{" "}
Post{" "}
</Link>
</div>

{/* /Review Tags */}
</div>
{/* /Service Details */}
{/* Member Details */}

<div className="col-lg-4">
<div className="theiaStickySidebar">
<div className="service-widget">

<div className="service-amt d-flex align-items-center justify-content-between">
<p>{Title.LABEL_PRICE}</p>
<h4>
{Str.get_money(val_app_cost)}{" "}
</h4>
</div>
<div className="service-amt d-flex align-items-center justify-content-between">
<p>{Title.LABEL_PAY_NOW}</p>
<h2>
{Str.get_money(val_app_pay_now_cost)}{" "}
</h2>
</div>



<Link to="#"  onClick={btn_post_preview_pay} data-bs-toggle="modal" data-bs-target="#order_details" className="btn btn-primary w-100">
<i className="feather icon-shopping-cart" />{Title.LABEL_BUY_THIS_APPLICATION}
</Link>

<div className="row gx-3 row-gap-3 mb-3">


<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
<div className="buy-box">
{product.application_type ? (<i className="feather icon-smartphone" />) :  (<i className="feather icon-layout" />) }
<p>{Title.LABEL_APP_TYPE}</p>
<h6>{product.application_type ? ("Mobile App") :  ("Website") }
</h6>
</div>
</div>


<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
<div className="buy-box">
<i className="feather icon-clock" />
<p>{Title.LABEL_DELIVERY_TIME}</p>
<h6>{App.get_app_delivery_time(product.delivery_time)}</h6>
</div>
</div>
<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
<div className="buy-box">
<i className="feather icon-eye" />
<p>{Title.LABEL_TOTAL_VIEWS}</p>
<h6>{product[Portal_Stat.POST_VIEW] ? product[Portal_Stat.POST_VIEW] : "0"}</h6>
</div>
</div>

<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
<div className="buy-box">
<i className="feather icon-dollar-sign" />
<p>Total Sales</p>
<h6>{product.order_count ? product.order_count : 0}</h6>
</div>
</div>

<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
<div className="buy-box">
<i className="feather icon-github" />
<p>Development Cost</p>
<h6>{Str.get_money(product.cost) ? Str.get_money(product.cost) : 0}</h6>
</div>
</div>



<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
{product.video_link && (
        <div className="buy-box">
        <Link to={product.video_link}>
        <i className="feather icon-youtube" />
        <p>Watch Demo</p>
        <h6>Youtube</h6>
        </Link>
        </div>
        )}
</div>

<div className="col-xl-4 col-lg-6 col-sm-4 col-6">
{product.download_link && (
        <div className="buy-box">
        <Link to={product.download_link}>
        <i className="feather icon-download" />
        <p>Download</p>
        <h6>Try Now</h6>
        </Link>
        </div>
        )}
</div>
</div>

<div className="service-widget">

<div className="service-widget service-select-widget">
<h5 className="mb-3">Payment Plan</h5>
{payment_plan_types.map((item,index) => (
            <div key={index} className="service-select d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
            <label className="custom_radio">
            <input onChange={update_payment_plan_type} type="radio" value={item.title} name="checkbox_payment_plan_type" checked={val_payment_plan_type_selected_title === item.title}  />
            <span className="checkmark" />
            <span className="m-0 service-head-text">
            {item.title}
            </span>
            </label>
            </div>
            <p className="price m-0">{Str.get_money(item.value)}</p>
            </div>
            ))}
</div>

<div className="service-widget service-select-widget">
<h5 className="mb-3"> Content $pecialist Assistant Weekly Hours  </h5>
{product_sub_spec_weekly_hour_items.map((item,index) => (
            <div key={index} className="service-select d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
            <label className="custom_radio">
            <input onChange={update_product_sub_spec_weekly_hour} type="radio" value={item.title} name="checkbox_product_spec_weekly_hour" checked={val_product_sub_spec_weekly_hour_selected_title === item.title}  />
            <span className="checkmark" />
            <span className="m-0 service-head-text">
            {item.title}
            </span>
            </label>
            </div>
            <p className="price m-0">{Str.get_money(item.cost)}</p>
            </div>
            ))}
</div>


<div className="service-widget service-select-widget">
<h5 className="mb-3"> Admin Panel </h5>
{product_sub_cms_items.map((item,index) => (
            <div key={index} className="service-select d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
            <label className="custom_radio">
            <input onChange={update_product_sub_cms} type="radio" value={item.title} name="checkbox_product_cms_type" checked={val_product_sub_cms_selected_title === item.title}  />
            <span className="checkmark" />
            <span className="m-0 service-head-text">
            {item.title}
            </span>
            </label>
            </div>
            <p className="price m-0">{Str.get_money(item.cost)}</p>
            </div>
            ))}
</div>

<div className="service-widget service-select-widget">
<h5 className="mb-3"> Hosting Type </h5>
{product_sub_hosting_type_items.map((item,index) => (
            <div key={index} className="service-select d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
            <label className="custom_radio">
            <input onChange={update_product_sub_hosting_type} type="radio" value={item.title} name="checkbox_product_hosting_type" checked={val_product_sub_hosting_type_selected_title === item.title}  />
            <span className="checkmark" />
            <span className="m-0 service-head-text">
            {item.title}
            </span>
            </label>
            </div>
            <p className="price m-0">{Str.get_money(item.cost)}</p>
            </div>
            ))}
</div>

<div className="service-widget service-select-widget">
<h5 className="mb-3"> Hosting Duration </h5>
{product_sub_hosting_duration_items.map((item,index) => (
            <div key={index} className="service-select d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
            <label className="custom_radio">
            <input onChange={update_product_sub_hosting_duration} type="radio" value={item.title} name="checkbox_product_hosting_duration" checked={val_product_sub_hosting_duration_selected_title === item.title}  />
            <span className="checkmark" />
            <span className="m-0 service-head-text">
            {item.title}
            </span>
            </label>
            </div>
            <p className="price m-0">{Str.get_money(item.cost)}</p>
            </div>
            ))}
</div>






</div>


</div>
</div>
</div>
{/* /Member Details */}
</div>
{/* Recent Work */}
<div className="recent-works">
<div className="row">
<div className="col-md-12">
<div className="title-sec">
<div className="row align-items-center">

<div className="col-md-8">
<h3>Related AppZ</h3>
</div>

<div className="col-md-4">
<div className="owl-nav worknav nav-control nav-top" />
</div>
</div>
</div>
<div className="gigs-slider">
<Slider {...imgslideroption}>
{products.map((item) => (
            <div key={item.id} className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"#"}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} className="img-fluid" alt="" />
            </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {item.featured == "true" && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {item.hot == "true" && (
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection">
                <Link to="#" className="fav-icon" >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={all_routes.product_app +"?" +item.category}>
                <span className="badge bg-primary-light">
                {item.category}
            </span>
                </Link>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"#"}>
                I will do creating and promoting video content to
                engage audiences
                </Link>
                </h3>
                </div>
                <div className="star-rate">
                <span>
                <i className="fa-solid fa-star" />
                4.2 (65 Reviews)
                </span>
                </div>
                <div className="gigs-card-footer">
                <div>
                <Link
                to="#"
                className="share-icon"
                >
                <i className="feather icon-share-2" />
                </Link>
                <span className="badge">Delivery in 1 day</span>
                </div>
                <h5>$600</h5>
                </div>
                </div>
                </div>
                ))}
                </Slider>
                </div>
                </div>
                </div>
                </div>
{/* /Recent Work */}
</div>
</div>
{/* /Content */}

{/* Order Details */}
<div
className="modal new-modal fade"
id="order_details"
data-keyboard="false"
data-backdrop="static"
>

<div className="modal-dialog modal-centered">
<div className="modal-content">
<div className="modal-header">
<h5 className="modal-title">Order Details</h5>
<button type="button" className="close-btn" data-bs-dismiss="modal">
<span>×</span>
</button>
</div>
<div className="modal-body service-modal">
<div className="row">
<div className="col-md-12">
<div className="order-status">
<div className="order-item">


<div style={{display: !product.image_filename ? 'none' : 'block'}} className="order-img">
<ImageWithBasePath src={Image.get_url(product.image_filename,Image_Format.SQUARE_THUMB)}  alt="" />
</div>
<div className="order-info">
<h5>
{product.title}
</h5>
<div >
</div>
<ul>
<li>Type : {product.type}</li>
</ul>
<ul>
<li>Delivery : {App.get_app_delivery_time(product.cost)}</li>
</ul>
<ul>
<li>Pay Now : {Str.get_money(val_app_pay_now_cost)}</li>
</ul>
</div>
</div>
<div className="detail-table table-responsive">

<table className="table">
<thead>

<tr>
<th>Title</th>
<th>Total</th>
</tr>

</thead>
<tbody>
<tr>
<td className="clip_title">{product.title}</td>
<td className="text-primary">{Str.get_money(product.cost)}</td>
</tr>
{cart.cart_items[0]?.cart_sub_items.map((item,index) => (
            <tr key={index}>
            <td>{item.parent.type}{" "}{item.parent.category}{":"}{<br/>}{item.title}</td>
            <td className="text-primary">{Str.get_money(item.cost)}</td>
            </tr>
            ))}
</tbody>
<tfoot>
<tr>
<th colSpan={1}>{Title.LABEL_GRAND_TOTAL}</th>
<th className="text-primary">{Str.get_money(cart.grand_total)}</th>
</tr>
</tfoot>
</table>
</div>
<div className="modal-btn">
<div className="row gx-2">
<div className="col-6">
<Link
to="#"
data-bs-dismiss="modal"
className="btn btn-secondary w-100 justify-content-center"
>
Cancel
</Link>
</div>
<div className="col-6">
<Link
to="#"
onClick={() => btn_post_pay()}
className="btn btn-primary w-100" >
{Title.LABEL_PAY_NOW}
</Link>

</div>
</div>
</div>

</div>
</div>
</div>
</div>
</div>
</div>
</div>
{/* /Order Details */}

<Modal_Image_Slide_Show images={detail_images} />
<Modal_Image_More_Slide_Show images={main_images} />
</>

);
};

export default Product_App_Detail;
